module.exports = __webpack_public_path__ + "img/new_20.28d47915.jpg";